__turbopack_context__.v({
  "disabled": "index-module-scss-module__mm9eZa__disabled",
  "error": "index-module-scss-module__mm9eZa__error",
  "field": "index-module-scss-module__mm9eZa__field",
  "input": "index-module-scss-module__mm9eZa__input",
  "label": "index-module-scss-module__mm9eZa__label",
  "selected": "index-module-scss-module__mm9eZa__selected",
});
